module.exports = __webpack_public_path__ + "static/media/Credits-17.2394eb67.pdf";